<template>
    <div class="dialog-body d-flex flex-column h-100">
        <div class="flex flex-grow-1 d-flex flex-column dialog-content overflow-auto">
            <v-toolbar>
                <div class="d-flex align-items-center pl-3">
                   <v-card-title class="text-h5 blue lighten-2">
                        {{ $t("res_Label_Transfer")}}
                    </v-card-title>
                </div>
                <v-spacer></v-spacer>
                 <v-btn class="close-btn light-btn tracker-close" icon dark @click="closeTransferDialog">
                        <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>

            <div class="border-top d-flex flex-wrap flex-fill">
                <div class="row px-5 py-5">
                    <div class="col-md-4">
                        <label>{{ $t("res_Label_Purpose")}}</label>
                        <v-select v-model="purpose" :disabled="disableFields" :items="purposes" item-text="name" item-value="id" label="" solo return-object></v-select>
                    </div>
                    <div class="col-md-4">
                        <label>{{ $t("res_CheckBox_MultiApproval")}}</label>
                        <v-checkbox  :disabled="disableFields" v-model="multiApproval" solo class=""></v-checkbox>
                    </div>
                    <div class="col-md-4">
                        <label>{{ $t("res_CheckBox_MultiApprovalForward")}}</label>
                          <v-checkbox  :disabled="disableFields" v-model="multiApprovalForward" solo class=""></v-checkbox>
                    </div>
                </div>
            </div>

            <div class="px-2" style="text-align: right">
                <v-btn color="primary"                          dense class="mx-2" @click="closeTransferDialog">{{ $t("res_ButtonText_Cancel")}}</v-btn>
                <v-btn color="primary" :disabled="disableFields" dense class="mx-2" @click="updateTransfer">{{ $t("res_ButtonText_Update")}}</v-btn>
                <v-btn color="primary" :disabled="disableFields" dense class="mx-2" @click="resetManageTransfersPopup">{{ $t("res_ButtonText_Reset")}}</v-btn>
            </div>
            
            <div class="px-5" >                    
                <v-data-table class="position-relative pt-5 hide_footer white" disable-sort :headers="transfersHeader"
                    :items="allTransfersData" :loading="loadingData" loading-text="loading..." :no-data-text="$t('res_Label_NoData')"
                    :footer-props="{ 'items-per-page-text': 'Items per page' }" caption="" 
                    :class="{'result_available': allTransfersData.length != 0}" hide-default-footer>
                    <template v-slot:item="row">
                        <tr>
                            <td style="display: none">{{ row.item.id }}</td>
                            <td>{{ row.item.fromStructureName }}</td>
                            <td>{{ row.item.fromUserFullName }}</td>
                            <td>{{ row.item.toStructureName }}</td>
                            <td>{{ row.item.toUserFullName }}</td>
                            <td>{{ row.item.purpose }}</td>
                            <td>{{ row.item.status }}</td>
                            <td>{{ dateFormat(row.item.dueDate, 'dd/MM/yyyy') }}</td>
                            <td>{{ dateFormat(row.item.createdDate, 'dd/MM/yyyy') }}</td>
                            <td>{{ row.item.multiApproval }}</td>
                            <td>{{ row.item.multiApprovalForward }}</td>
                            <td>
                                <div class="d-flex">
                                    <v-btn class="white--text" :disabled="row.item.statusId == 4"   
                                        elevation="2" color="#00ae8d" 
                                        @click="editCurrentTransfer(row.item)">{{ $t("res_ButtonText_Edit")}}</v-btn>
                                    <v-btn class="white--text ml-3" :disabled="row.item.statusId != 4" 
                                        elevation="2" color="#ff902b" @click="reactivateCurrentTransfer(row.item.id)">
                                        {{ $t("res_ButtonText_Reactivate")}}
                                    </v-btn>
                                    <v-btn class="white--text ml-3" :disabled="row.item.statusId == 4" 
                                        elevation="2" color="#ff902b" @click="deleteCurrentTransfer(row.item.id)">
                                        {{ $t("res_ButtonText_Delete")}}
                                    </v-btn>
                                </div>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </div>
        </div>
    </div>
</template>

<script>
    import { defaultGet, defaultPost } from '@/assets/js/common.js'
    import constants from '@/assets/js/constants.js'
    import axios from 'axios'
    import { getTransferPurposes } from '@/store/modules/lookups.js'
    import MultiSelect  from 'vue-multiselect'
    
	export default {
		name: 'ManageSigners',
        components: { MultiSelect },
        props: {
            refreshToken: { type: String, default: '' },
        },
		data() {
            return {
                loadingData: false,
                disableFields: true,
                currentTransferId: '',
                allTransfersData: [],
                transfersHeader: [
                    { text: 'Id',                       value: 'id',                    align: ' d-none'},
                    { text: 'From StructureName',       value: 'fromStructureName',     width: '8%' },
                    { text: 'From UserName',            value: 'fromUserFullName',      width: '10%' },
                    { text: 'To StructureName',         value: 'toStructureName',       width: '8%' },
                    { text: 'To UserName',              value: 'toUserFullName',        width: '10%' },
                    { text: 'Purpose',                  value: 'purpose',               width: '8%' },
                    { text: 'Status',                   value: 'status',                width: '8%' },
                    { text: 'Due Date',                 value: 'dueDate',               width: '10%' },
                    { text: 'Created Date',             value: 'createdDate',           width: '10%' },
                    { text: 'Multi Approval',           value: 'multiApproval',         width: '5%' },
                    { text: 'Multi Approval Forward',   value: 'multiApprovalForward',  width: '5%' },
                    { text: 'Actions',                  value: '',                      width: '20%' }
                ],
                multiApproval: false,
                multiApprovalForward: false,
                dateFormat: window.dateFormatForExternlUse,
                purpose: {},
                purposes: [],
            };
        },
        props: 
        {
            documentId:      { type: [String, Number],  default: 0     },
            dialogModelShow: { type: Boolean, default: false }, 
        },
        watch: 
        {
            dialogModelShow(newVal, oldVal)
            {
                if (newVal != oldVal)
                {
                    if (newVal == true)
                    { 
                        this.getAllTransfers();
                    }
                    else
                    {
                        this.resetManageTransfersPopup()
                    }
                }
            },
        },
        mounted: function () 
        {
            this.getAllTransfers()
            this.getAllPurposes()
        },
        methods: 
        {
            getAllTransfers() 
            {
                this.allTransfersData = [];
                axios.get(constants.baseApiUrl + 'Transfer/GetAllTransfersByDocumentId?documentId=' + this.documentId, { headers: constants.headers })
                    .then((res) => 
                    {
                        if (res.data != null)
                        {
                            this.allTransfersData = res.data;
                        }
                    }).catch(err => console.warn(err))
            },
            getAllPurposes()
            {
                this.purposes = getTransferPurposes();
            },
            resetManageTransfersPopup()
            {
                this.disableFields = true;
                this.multiApproval = false
                this.multiApprovalForward = false
                this.purpose = {}
            },
            closeTransferDialog()
            {
                this.disableFields = true;
                this.$emit('closeTransfersDialog', 0)
            },
            editCurrentTransfer(transfer)
            {
                this.disableFields = false;
                this.currentTransferId = transfer.id;
                this.multiApproval = transfer.multiApproval == null || transfer.multiApproval == undefined ? 0 : transfer.multiApproval;
                this.multiApprovalForward = transfer.multiApprovalForward == null || transfer.multiApprovalForward == undefined ? 0 : transfer.multiApprovalForward;
                this.purpose = this.purposes.find(x => x.name == transfer.purpose);
            },
            updateTransfer()
            {
                var updateTransfer = 
                {
                    TransferId: this.currentTransferId,
                    MultiApproval: this.multiApproval,
                    MultiApprovalForward: this.multiApprovalForward,
                    PurposeId: this.purpose.id
                }
                axios.post(constants.baseApiUrl + 'Transfer/UpdateTransfer', updateTransfer, { headers: constants.headers })
                    .then((res) => 
                    {
                        if (res.data != null && res.data == true)
                        {
                            window.showAlert('res_Msgs_TransferUpdated', 'success')
                            this.resetManageTransfersPopup()
                            this.getAllTransfers();
                        }
                    }).catch(err => console.warn(err))
            },
            deleteCurrentTransfer(transferId)
            {
                window.showInformation('res_Msgs_Confirmation', window.translate("res_Msgs_TransferDeleteConfirmation"),
                    () => 
                    { 
                        axios.post(constants.baseApiUrl + 'Transfer/DeactivateTransfer?transferId=' + transferId, { headers: constants.headers })
                            .then(res => 
                            {
                                if (res.data != null && res.data > 0)
                                {
                                    window.showAlert('res_Msgs_TransferDeleted', 'success')
                                    this.getAllTransfers();
                                }
                            })
                            .catch(err => console.warn(err))
                    }, () =>{ })
            },
            reactivateCurrentTransfer(transferId)
            {
                axios.post(constants.baseApiUrl + 'Transfer/ReactivateTransfer?transferId=' + transferId, { headers: constants.headers })
                    .then(res => 
                    {
                        if (res.data != null && res.data > 0)
                        {
                            window.showAlert('res_Msgs_TransferReactivated', 'success')
                            this.getAllTransfers();
                        }
                    })
                    .catch(err => console.warn(err))
            }
        }
	}
</script>

<style scoped>
    .template_filter_container { justify-content: space-between; align-items: flex-end; }
    .template_card:hover,  .template_card:focus  {background-color: #f1f8ff !important}
    .template_selected { border: 1px solid #205CDF }
    .template_card:hover .v-chip.purple,  .template_card:focus .v-chip.purple {
        background: #fff !important;
        color: #5C068C !important;
    }
    .template_filter {flex: 1; }
</style>